import axios from "axios"
import { AnyObject } from "chart.js/dist/types/basic"
import { getJWT } from "src/helper/localStore/getJWT"

const ASSIGNED_TYPE = 0;
const WATCHED_TYPE = 1;
const CREATED_TYPE = 2;

class NotificationServices {
    async getStatuses(): Promise<any[]> {
        try{
            const res = await axios.get(
            `${process.env.REACT_APP_URL_REDMINE}/redmine/issue_statuses`,
            {
                headers: {
                'authentication-token': getJWT()!,
                }
            }
            )
            return res.data || {}
        }catch(error){
            throw error
        }
    }

    async getProjects(): Promise<any[]> {
        try{
            const res = await axios.get(
            `${process.env.REACT_APP_URL_REDMINE}/redmine/projects`,
            {
                headers: {
                'authentication-token': getJWT()!,
                }
            }
            )
            return res.data || {}
        }catch(error){
            throw error
        }
    }

    async getFollowers(projectId:number): Promise<any[]> {
        try{
            const res = await axios.get(
            `${process.env.REACT_APP_URL_REDMINE}/redmine/projects_users/${projectId}/memberships`,
            {
                headers: {
                'authentication-token': getJWT()!,
                }
            }
            )
            return res.data || {}
        }catch(error){
            throw error
        }
    }

    async getNotificationByParam(params:Object): Promise<any[]> {
        try{
            const res = await axios.get(
            `${process.env.REACT_APP_URL_REDMINE}/redmine/issues/search`,
            {
                headers: {
                'authentication-token': getJWT()!,
                },
                params
            }
            )
            return res.data || {}
        }catch(error){
            throw error
        }
    }

    async getAssignedNotification(prefilter:any = null): Promise<any[]> {
        try{
            let status_param = ''
            let params:any = {...prefilter}
            if(prefilter){
                if(prefilter.status?.length > 0){
                    for(let status of prefilter.status){
                        status_param = status_param + status + '|'
                    }
                    status_param = status_param.slice(0, -1);
                    params['status'] = status_param
                }
                if(prefilter.description){
                    params['description'] = prefilter.description.replaceAll(' ', '+')
                }
            }
            const res = await axios.get(
            `${process.env.REACT_APP_URL_REDMINE}/redmine/assigned_tickets`,
            {
                headers: {
                'authentication-token': getJWT()!,
                },
                params
            }
            )
            return res.data || {}
        }catch(error){
            throw error
        }
    }

    async getWatchedNotification(prefilter:any = null): Promise<any[]> {
        try{
            let status_param = ''
            let params:any = {...prefilter}
            if(prefilter){
                if(prefilter.status?.length > 0){
                    for(let status of prefilter.status){
                        status_param = status_param + status + '|'
                    }
                    status_param = status_param.slice(0, -1);
                    params['status'] = status_param
                }
                if(prefilter.description){
                    params['description'] = prefilter.description.replaceAll(' ', '+')
                }

            }
            
            const res = await axios.get(
            `${process.env.REACT_APP_URL_REDMINE}/redmine/watched_tickets`,
            {
                headers: {
                'authentication-token': getJWT()!,
                },
                params
            }
            )
            return res.data || {}
        }catch(error){
            throw error
        }
    }

    async getCreatedNotification(prefilter:any = null): Promise<any[]> {
        try{
            let status_param = ''
            let params:any = {...prefilter}
            if(prefilter){
                if(prefilter.status?.length > 0){
                    for(let status of prefilter.status){
                        status_param = status_param + status + '|'
                    }
                    status_param = status_param.slice(0, -1);
                    params['status'] = status_param
                }
                if(prefilter.description){
                    params['description'] = prefilter.description.replaceAll(' ', '+')
                }
                
            }
            const res = await axios.get(
            `${process.env.REACT_APP_URL_REDMINE}/redmine/created_tickets`,
            {
                headers: {
                'authentication-token': getJWT()!,
                },
                params
            }
            )
            return res.data || {}
        }catch(error){
            throw error
        }
    }

    async postNotification(formData:FormData): Promise<any[]> {
        try{
            const res = await axios.post(
            `${process.env.REACT_APP_URL_REDMINE}/redmine/issues`,
            formData,
            {
                headers: {
                'authentication-token': getJWT()!,
                },
            }
            )
            return res.data || {}
        }catch(error){
            throw error
        }
    }

    async editNotification(formData:Object, issue_id:number): Promise<any> {
        try{
            const res = await axios.put(
            `${process.env.REACT_APP_URL_REDMINE}/redmine/issues`,
            formData,
            {
                headers: {
                'authentication-token': getJWT()!,
                },
                params:{
                    issueID:issue_id
                }
            }
            )
            return res || {}
        }catch(error){
            throw error
        }
    }

    async removeWatcher(issue_id:number, watcher_id:number): Promise<any> {
        try{
            const res = await axios.delete(
            `${process.env.REACT_APP_URL_REDMINE}/redmine/issues/${issue_id}/watchers/${watcher_id}`,
            {
                headers: {
                'authentication-token': getJWT()!,
                },
                params:{
                    issueID:issue_id
                }
            }
            )
            return res || {}
        }catch(error){
            throw error
        }
    }

    async getAllUsers(): Promise<any> {
        try{
        const res = await axios.get(
            `${process.env.REACT_APP_URL_REDMINE}/redmine/users`,
            {
                headers: {
                'authentication-token': getJWT()!,
                }
            }
            )
            return res || {}
        }catch(error){
            throw error
        }
    }

    async getAllGroups(): Promise<any> {
        try{
        const res = await axios.get(
            `${process.env.REACT_APP_URL_REDMINE}/redmine/groups`,
            {
                headers: {
                'authentication-token': getJWT()!,
                }
            }
            )
            return res || {}
        }catch(error){
            throw error
        }
    }

    async downloadFile(id:number, filename:string): Promise<any> {
        try{
            const res = await axios.get(
                `${process.env.REACT_APP_URL_REDMINE}/redmine/attachments/download/${id}/${filename}`,
                {
                    headers: {
                    'authentication-token': getJWT()!,
                    },
                    responseType: 'blob'
                }
                )
                return res || {}
            }catch(error){
                throw error
            }
    }

    async generalSearch(field:string, search:string): Promise<any> {
        try{
            const res = await axios.get(
                `${process.env.REACT_APP_URL_REDMINE}/redmine/issues/search`,
                {
                    params:{
                        [field]:search
                    },
                    headers: {
                    'authentication-token': getJWT()!,
                    }
                }
                )
                return res || {}
            }catch(error){
                throw error
            }
    }

    async export(prefilter:AnyObject,notificationsType:number): Promise<any> {
        try{
            let status_param = ''
            let params:any = {}
            if(prefilter){
                if(prefilter.status?.length > 0){
                    for(let status of prefilter.status){
                        status_param = status_param + status + '|'
                    }
                    status_param = status_param.slice(0, -1);
                    params['status'] = status_param
                }
                if(prefilter.project){
                    params['project'] = prefilter.project
                }
                if(prefilter.subject){
                    params['subject'] = prefilter.subject
                }
                if(prefilter.created_from){
                    params['created_from'] = prefilter.created_from
                }
                if(prefilter.created_until){
                    params['created_until'] = prefilter.created_until
                }
                if(prefilter.asignated_to){
                    params['asignated_to'] = prefilter.asignated_to
                }
                if(notificationsType === ASSIGNED_TYPE){
                    params['rol'] = 'assigned_to'
                } else if(notificationsType === WATCHED_TYPE){
                    params['rol'] = 'watcher'
                } else if(notificationsType === CREATED_TYPE){
                    params['rol'] = 'author'
                }
            }
            const res = await axios.get(
                `${process.env.REACT_APP_URL_REDMINE}/redmine/export`,
                {
                    params,
                    headers: {
                    'authentication-token': getJWT()!,
                    }
                }
                )
                return res || {}
            }catch(error){
                throw error
            }
    }

    async getUsersAndGroups(): Promise<any> {
        try{
        const res = await axios.get(
            `${process.env.REACT_APP_URL_REDMINE}/redmine/projects/memberships`,
            {
                headers: {
                'authentication-token': getJWT()!,
                }
            }
            )
            return res || {}
        }catch(error){
            throw error
        }
    }
}

export const notificationServices = new NotificationServices()